import React, { type ReactNode } from 'react';

import { type Knowledge } from '@atlassian/conversation-assistant-agent/ui/KnowledgePillList';
import { type ExperienceNameType } from '@atlassian/conversation-assistant-instrumentation/constants/experience-tracker';
import { ExperienceSuccess } from '@atlassian/conversation-assistant-instrumentation/ui/ExperienceTracker';

import { CreateAgentCardPlan } from './CreateAgentCardPlan';
import { CreateAgentCardPublished } from './CreateAgentCardPublished';
import { type Tool } from './ExpandableBody';

export type CreateAgentCardProps = {
	isPublished?: boolean;
	agentAri?: string;
	agentName: string;
	cloudId?: string;
	description: string;
	instructions: string;
	knowledge: Knowledge[];
	tools: Tool[];
	primaryAction?: ReactNode;
	secondaryAction?: ReactNode;
	imageUrl?: string;
	agentIdentityAccountId?: string;
	agentNamedId?: string;
	agentEditUrl?: string;
	renderExperienceName?: ExperienceNameType;
	shouldRenderDetailedPublishedCard?: boolean;
};

export const CreateAgentCard = ({
	isPublished = false,
	agentAri,
	agentName,
	cloudId,
	description,
	instructions,
	knowledge,
	tools,
	primaryAction,
	secondaryAction,
	imageUrl,
	agentIdentityAccountId,
	agentNamedId,
	agentEditUrl,
	renderExperienceName,
	shouldRenderDetailedPublishedCard = false,
}: CreateAgentCardProps): React.JSX.Element => {
	if (isPublished && !shouldRenderDetailedPublishedCard) {
		return (
			<>
				{renderExperienceName && <ExperienceSuccess name={renderExperienceName} />}
				<CreateAgentCardPublished
					agentAri={agentAri || ''}
					agentName={agentName}
					imageUrl={imageUrl}
					agentIdentityAccountId={agentIdentityAccountId}
					agentNamedId={agentNamedId}
					agentEditUrl={agentEditUrl}
				/>
			</>
		);
	}

	return (
		<>
			{renderExperienceName && <ExperienceSuccess name={renderExperienceName} />}
			<CreateAgentCardPlan
				agentAri={agentAri}
				agentName={agentName}
				cloudId={cloudId}
				description={description}
				instructions={instructions}
				knowledge={knowledge}
				tools={tools}
				imageUrl={imageUrl}
				agentIdentityAccountId={agentIdentityAccountId}
				agentNamedId={agentNamedId}
				status={isPublished ? 'published' : undefined}
				primaryAction={primaryAction}
				secondaryAction={secondaryAction}
				testId="rovo-create-agent-card-wrapper"
			/>
		</>
	);
};
